module.exports = __webpack_public_path__ + "img/5.47572ee5.jpg";